/**
 * `reservations` — une œuvre tenue pour quelqu'un (base galerie, 4.1).
 *
 * Une réservation pose le statut « réservée » et expire d'elle-même (4.2).
 */
import { z } from 'zod';
import { CHAMPS_DOCUMENT, idSchema, withAudit } from './commun.js';
export const ETATS_RESERVATION = ['active', 'expiree', 'levee', 'transformee'];
export const etatReservationSchema = z.enum(ETATS_RESERVATION);
export const reservationSchema = withAudit(z.object({
    _id: idSchema,
    oeuvreId: idSchema,
    exemplaireId: idSchema.optional(),
    contactId: idSchema,
    jusquau: z.date(),
    note: z.string().optional(),
    etat: etatReservationSchema.default('active'),
    leveeLe: z.date().optional(),
}));
export const reservationCreationSchema = reservationSchema.omit({
    ...CHAMPS_DOCUMENT,
    etat: true,
    leveeLe: true,
});
export const reservationMiseAJourSchema = reservationSchema
    .pick({ jusquau: true, note: true, etat: true })
    .partial();
//# sourceMappingURL=reservations.js.map